import React, { useEffect, useState } from 'react';

import Chip from '@mui/material/Chip';
import './MediaComponent.css';

import { getImageThumbnailUrl } from '../../../services/mediaService';

//const options = { timeZone: 'Europe/Budapest', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' };

const Media = ({
  categories,
  size,
  currentIndex,
  data,
  onClick

}) => {

  const [isImageAvailable, setIsImageAvailable] = useState(null);
  const [imageLoaded, setImageLoaded] = useState(false);

  const fullUrl = getImageThumbnailUrl(data[currentIndex].id);
  useEffect(() => {
    setIsImageAvailable(null);
    setImageLoaded(false);

    const image = new Image();
    image.src = fullUrl;

    image.onload = () => {
      setIsImageAvailable(true);
      setImageLoaded(true);
    };

    image.onerror = () => {
      setIsImageAvailable(false);
      setImageLoaded(false);
    };
  }, [fullUrl]);

  const getCategoryNames = (itemCategory, fallbackCategory, id) => {
    const unknownCategory = { name: 'Ismeretlen', is_parent: false }
    const itemCategories = [];
    let raw = itemCategory;
    if ((!raw || raw === '') && fallbackCategory) raw = fallbackCategory;

    if (Array.isArray(raw)) {
      raw.forEach((element) => {
        const id = parseInt(element);
        const category = categories.find((cat) => cat.id === id);
        itemCategories.push(category ? category : unknownCategory);
      });
      return itemCategories.length ? itemCategories : [unknownCategory];
    }

    if (typeof raw === 'string' && raw.trim().startsWith('[')) {
      try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          return getCategoryNames(parsed);
        }
      } catch (e) {
        // fallthrough to treat as comma-separated
      }
    }

    if (typeof raw === 'string' && raw.includes(',')) {
      const parts = raw.split(',').map((s) => s.trim()).filter(Boolean);
      parts.forEach((element) => {
        const id = parseInt(element);
        const category = categories.find((cat) => cat.id === id);
        itemCategories.push(category ? category : unknownCategory);
      });
      return itemCategories.length ? itemCategories : [unknownCategory];
    }

    if (raw) {
      const id = parseInt(raw);
      if (!isNaN(id)) {
        const category = categories.find((cat) => cat.id === id);
        itemCategories.push(category ? category : unknownCategory);
        return itemCategories;
      }

      itemCategories.push(raw);
      return itemCategories;
    }

    return [unknownCategory];
  };

  return (
    <div className="media-cell">
      <div className="media-container" >
        {isImageAvailable === null ? (
          <span>Töltés...</span>
        ) : data[currentIndex].mimetype && data[currentIndex].mimetype.startsWith('video/') ? (
          <div className="video-thumbnail-wrapper" style={{ width: size, height: size, cursor: 'pointer' }} onClick={onClick}>
            {isImageAvailable ? (
              <img
                src={fullUrl}
                alt="Video Thumbnail"
                className={`thumbnail ${imageLoaded ? 'fade-in' : ''}`}
                style={{ width: size, height: size }}
              />
            ) : (
              <i className="bi bi-file-earmark-play" style={{ fontSize: size }} />
            )}
            <i className="bi bi-play-circle-fill video-play-icon" />
          </div>
        ) : isImageAvailable ? (
          <img
            src={fullUrl}
            alt="Thumbnail"
            className={`thumbnail ${imageLoaded ? 'fade-in' : ''}`}
            style={{ width: size, height: size, cursor: 'pointer' }}
            onClick={onClick}
          />

        ) : (
          <i className="bi bi-file-earmark-image" style={{ fontSize: size }} />
        )}
        <div className="media-info">
          <p className="mb-0">Készítés ideje: {data[currentIndex].created_time ? new Date(data[currentIndex].created_time * 1000).toLocaleDateString('hu-HU') : '-'}</p>
          <p>Feltöltés ideje: {new Date(data[currentIndex].upload_time * 1000).toLocaleDateString('hu-HU')}</p>
          {getCategoryNames(data[currentIndex].categories, data[currentIndex].category, data[currentIndex].id).sort((a, b) => Number(b.is_parent) - Number(a.is_parent))
            .map((category, index) => (
              category.is_parent ? (
                <li key={index} className="main-category">
                  {category.name}
                  <div>
                    <a href={fullUrl} target="_blank" rel="noopener noreferrer">
                      Eredeti megnyitása
                    </a>
                  </div>
                </li>
              ) : (
                <Chip
                  key={index}
                  label={category.name}
                  className="sub-category-chip"
                  style={{ margin: '4px' }}
                />
              )
            ))}
        </div>
      </div>

    </div>

  );
};

export default Media;
